import { render } from "./DmoPerfetto.vue?vue&type=template&id=45c005ca&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./DmoPerfetto.vue?vue&type=script&lang=ts"
export * from "./DmoPerfetto.vue?vue&type=script&lang=ts"

import "./DmoPerfetto.vue?vue&type=style&index=0&id=45c005ca&scoped=true&lang=css"
import "./DmoPerfetto.vue?vue&type=style&index=1&id=45c005ca&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c005ca"]])

export default __exports__